import {CALL_CANCELLED} from 'src/pages/scheduleCallback/constants/views';
import {cancelAppointmentStep} from 'src/pages/scheduleCallback/store/actions/cancelAppointmentStep';
import {hasAppointment} from 'src/pages/scheduleCallback/store/selectors/app';
import {fragment} from 'src/pages/scheduleCallback/utils';
import {changeView} from 'src/shared/currentView/actions';
import {logScreenName} from 'src/shared/dataLayer/loggers';
import {pushHistory} from 'src/shared/history/actions';

export const appointmentCancelationConfirmationStep = () => (dispatch, getState) => {
  if (hasAppointment(getState())) {
    return dispatch(cancelAppointmentStep());
  }
  dispatch(pushHistory(appointmentCancelationConfirmationStep(), fragment('canceled')));
  dispatch(changeView(CALL_CANCELLED));
  logScreenName('cancelconfirm');
};
